import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { delay, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LazyLoadVirtualImageService {

  private renderer: Renderer2;
  private observer: IntersectionObserver | null = null;
  private imageElements = new Set<HTMLImageElement>();
  scrollTimeout:any;
  static lazyImageServiceRef: any;
  imageObservable = new Subject<{
    entry: IntersectionObserverEntry;
    observer: IntersectionObserver;
  }>();


  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.initializeObserver();
    this.checkIntersectionWithTimeDelay();
    LazyLoadVirtualImageService.lazyImageServiceRef = this;
  }
  
  private initializeObserver() {
    if (this.observer) {
      this.observer.disconnect();
    }
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };
    this.observer = new IntersectionObserver(this.imageIntersected,options);
  }

  registerImage(image: HTMLImageElement) {
    if (!this.imageElements.has(image)) {
      this.imageElements.add(image);
      if (this.observer) {
        this.observer.observe(image);
      }
    }
  }

  unregisterImage(image: HTMLImageElement) {
    if (this.imageElements.has(image)) {
      this.imageElements.delete(image);
      this.observer?.unobserve(image);
    }
  }

  private setImageSrc(image: HTMLImageElement) {
    const src = image.getAttribute('data-src');
    if (src) {
      this.renderer.setAttribute(image, 'src', src);
      this.unregisterImage(image);
    }
  }

  imageIntersected(entries,observer){
    var self = LazyLoadVirtualImageService.lazyImageServiceRef;
    entries.forEach((entry) => {
      const sectionDiv = entry.target;
      sectionDiv.time = entry.time;
      if (entry.isIntersecting) {
        self.imageObservable.next({ entry, observer});
      }
    });
  }

  checkIntersectionWithTimeDelay(){
    var self = this;
    this.imageObservable.pipe(delay(350))
    .subscribe(async ({ entry, observer }) => {
      let id = document.querySelector('#'+entry.target.id);
      if(!id){  // this condition is added to ignore the images which are not present in the DOM
        this.unregisterImage(entry.target as HTMLImageElement)
      }
      let intersected = await self.checkIfTheElementIsInViewForMoreThanDefinedSeconds(entry.target.id)
      if(intersected){
        const img = entry.target as HTMLImageElement;
        this.setImageSrc(img);
      }
    })
  }


  checkIfTheElementIsInViewForMoreThanDefinedSeconds(target){
    let id = document.querySelector('#'+target);
    if(!id){
      return false;
    }
    return new Promise(resolve => {
      const observer = new IntersectionObserver(([entry]) => {
        resolve(entry.intersectionRatio > 0);
        observer.disconnect();
      });
      observer.observe(id);
    });
  }



}
